<template>
  <el-row>
    <el-col :sm="col.sm" :md="col.md">
      <el-card>
        <header slot="header">
          <el-image id="logo" :src="logo" fit="fit"></el-image>
        </header>
        <el-form
          v-if="showForm"
          :model="form"
          :rules="rules"
          ref="form"
          label-position="top"
          label-width="100px"
          status-icon
        >
          <el-form-item label="Contraseña" prop="password">
            <el-input
              placeholder="Ingresa tu nueva contraseña"
              v-model="form.password"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="Repetir contraseña" prop="repeatPassword">
            <el-input
              placeholder="Repite la contraseña"
              v-model="form.repeatPassword"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit" :loading="loading" :disabled="loading"
              >Cambiar contraseña</el-button
            >
          </el-form-item>
        </el-form>
        <main v-else>
          <p>Tu contraseña fue actualizada exitosamente.</p>
          <p>Vuelve a
            <el-link type="primary" href="https://play.google.com/store/apps/details?id=com.picker.cp">iniciar sesión</el-link>.
          </p>
        </main>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { resetPassword } from "../services/user.service";

const logo = require("@/assets/logo.png");

export default {
  name: "Home",
  mounted() {
    const { path } = this.$route;
    const token = path.slice(1);
    this.token = token;
  },
  data() {
    const validatePass = (rule, value, cb) => {
      if (!value) {
        cb(new Error("Por favor ingresa tu nueva contraseña"));
      } else {
        cb();
      }
    };
    const validateRepeatPass = (rule, value, cb) => {
      if (!value) {
        cb(new Error("Por favor repite tu contraseña"));
      } else if (value !== this.form.password) {
        cb(new Error("Contraseñas no coinciden"));
      } else {
        cb();
      }
    };
    return {
      col: {
        md: { span: 8, offset: 8 },
        sm: { span: 24 },
      },
      form: {
        password: "",
        repeatPassword: "",
      },
      rules: {
        password: [
          { validator: validatePass, trigger: "blur" },
          { min: 6, message: "La contraseña debe de tener por lo menos 6 caracteres", trigger: "blur" },
        ],
        repeatPassword: [{ validator: validateRepeatPass, trigger: "blur" }],
      },
      logo,
      token: "",
      loading: false,
      showForm: true,
    };
  },
  methods: {
    validate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) return resolve(true);
          return resolve(false);
        });
      });
    },
    async submit() {
      try {
        this.loading = true;
        const valid = await this.validate();
        if (!valid) {
          this.loading = false;
          return;
        }
        const payloadData = {
          newPassword: this.form.password,
          passwordResetToken: this.token,
        };
        await resetPassword(payloadData);
        this.loading = false;
        this.showForm = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
        const title = "Error";
        this.$alert(error, title, {
          confirmButtonText: "Ok",
        });
      }
    },
  },
};
</script>

<style>
.el-form-item__label {
  float: left !important;
}
#logo {
  height: 200px;
  width: 200px;
}

.el-message-box {
    width: 500px !important;
  }
@media screen and (max-width: 992px) {
  .el-message-box {
    width: 80% !important;
  }
}
</style>
